// components/NotificacionSoporte.jsx
// Globo emergente cuando un cliente solicita un asesor en el chat.
// Al hacer clic lleva a Soporte y abre esa conversación.
import React from "react";
import "./NotificacionSoporte.css";

export default function NotificacionSoporte({ items, onAbrir, onDescartar }) {
  if (!items || items.length === 0) return null;

  return (
    <div className="nsop-zona">
      {items.map((c) => (
        <div key={c.id} className="nsop-globo" role="alert">
          <button
            className="nsop-cerrar"
            onClick={(e) => { e.stopPropagation(); onDescartar(c.id); }}
            title="Descartar"
          >
            ✕
          </button>

          <div className="nsop-icono">💬</div>

          <div className="nsop-cuerpo" onClick={() => onAbrir(c.id)}>
            <div className="nsop-titulo">Cliente solicita asesor</div>
            <div className="nsop-nombre">{c.nombre || "Sin nombre"}</div>
            {c.telefono && <div className="nsop-dato">📞 {c.telefono}</div>}
            {(c.colonia || c.ciudad) && (
              <div className="nsop-dato">📍 {c.colonia || c.ciudad}</div>
            )}
            {c.ultimo_mensaje && (
              <div className="nsop-msg">“{c.ultimo_mensaje}”</div>
            )}
            <button className="nsop-boton" onClick={() => onAbrir(c.id)}>
              Atender ahora →
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
